import React from "react";
import { useHistory } from "react-router-dom";
import isScript from "../../hooks/isScript";
import MailForm from "../mailForm/mailForm";
import { useTranslation } from "react-i18next";

const PricingPage = () => {
  const history = useHistory();
  isScript();

  const { t } = useTranslation("pricing");
  const { t: isLang } = useTranslation("type");

  if (isLang("lang") === "en") {
    location.replace("/");
    return;
  }

  return (
    <>
      <main className="main pricing">
        <section className="banner-main">
          <div className="inner">
            <div>
              <img
                className="logo fade-up"
                src="./assets/logo/logo_bk.png"
                alt="Ready Play Logo"
              />
              <h2 className="sub-tit fade-up">
                {t("banner.subTit_01")}
                <br />
                {t("banner.subTit_02")}
              </h2>
            </div>
            <div className="fade-up wh100">
              <span className="tooltip bounce">
                <ion-icon name="mail"></ion-icon>&ensp;
                {t("banner.toolTip")}
              </span>
              <a href="#contact" className="btn-main">
                {t("banner.contact")}
              </a>
            </div>
          </div>
        </section>

        <section className="container plan">
          <div className="inner">
            <div className="fade-up">
              <h2 className="main-tit .md clearfix">
                <span className="left">
                  <em>Standard</em> {t("plan.mainTit")}
                </span>
                <span className="right">
                  <small>₩</small>3,000,000
                </span>
              </h2>
              <h3 className="desc clearfix">
                <small className="left">{t("plan.mainDesc_01")}</small>
                <small className="right">({t("plan.mainDesc_02")})</small>
              </h3>
            </div>
            <div className="table-wrapper standard fade-up">
              <div className="table-grid__header">
                <section className="column">
                  <div className="tit">
                    <b>{t("plan.standTit_01")}</b>
                  </div>
                  <div className="col-20">
                    <b>Standard</b>
                  </div>
                </section>
              </div>
              <div className="table-grid__body">
                <div className="column">
                  <div className="tit">
                    <b>{t("plan.standTit_02")}</b>
                  </div>
                  <div>{t("plan.avatar")}</div>
                  <div className="col-8">{t("plan.vSpace")}</div>
                  <div className="col-16">{t("plan.function")}</div>
                  <div className="col-18">{t("plan.participants")}</div>
                  <div>{t("plan.duration")}</div>
                  <div>{t("plan.report")}</div>
                  <div>CMS</div>
                </div>
                <div className="column">
                  <div className="tit">
                    <b>{t("plan.standTit_03")}</b>
                  </div>
                  <div>{t("plan.av_td_01")}</div>
                  <div>{t("plan.vs_td_01")}</div>
                  <div>{t("plan.vs_td_02")}</div>
                  <div>{t("plan.vs_td_03")}</div>
                  <div>{t("plan.vs_td_04")}</div>
                  <div>{t("plan.vs_td_05")}</div>
                  <div>{t("plan.fc_td_01")}</div>
                  <div>{t("plan.fc_td_02")}</div>
                  <div>{t("plan.fc_td_03")}</div>
                  <div>{t("plan.fc_td_04")}</div>
                  <div>{t("plan.fc_td_05")}</div>
                  <div>{t("plan.fc_td_06")}</div>
                  <div>{t("plan.fc_td_07")}</div>
                  <div>{t("plan.fc_td_08")}</div>
                  <div className="col-18">{t("plan.pc_td_01")}</div>
                  <div>{t("plan.dr_td_01")}</div>
                  <div>{t("plan.rp_td_01")}</div>
                  <div>{t("plan.cms_td_01")}</div>
                </div>
                <div className="column">
                  <div className="tit">
                    <b>{t("plan.standTit_04")}</b>
                  </div>
                  <div className="col-7">
                    <ion-icon
                      name="checkmark-outline"
                      className="icon-check"
                    ></ion-icon>
                  </div>
                  <div>
                    <ion-icon
                      name="checkmark-outline"
                      className="icon-check"
                    ></ion-icon>
                  </div>
                  <div>{t("plan.vs_td_06")}</div>
                  <div className="col-14">
                    <ion-icon
                      name="checkmark-outline"
                      className="icon-check"
                    ></ion-icon>
                  </div>
                  <div>
                    <p>
                      {t("plan.fc_td_09")}
                      <small className="mb">(Speaker Only)</small>
                    </p>
                  </div>
                  <div>{t("plan.fc_td_10")}</div>
                  <div className="col-18">
                    <p>
                      {t("plan.pc_td_02")}
                      <br />
                      <small className="mb">
                        Avatar : 20 / Voice Only : 30+
                      </small>
                    </p>
                  </div>
                  <div>{t("plan.dr_td_02")}</div>
                  <div>{t("plan.rp_td_02")}, ID</div>
                  <div>
                    <ion-icon
                      name="close-outline"
                      className="icon-close"
                    ></ion-icon>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-wrapper optional">
              <div className="table-grid">
                <section className="column">
                  <div className="col-1">
                    <b>Optional</b>
                  </div>
                </section>
              </div>
              <div className="table-grid__body">
                <div className="column">
                  <div className="col-1">
                    <b>{t("plan.optTit_01")}</b>
                  </div>
                </div>
                <div className="column">
                  <div>{t("plan.custom_td_01")}</div>
                  <div>{t("plan.custom_td_02")}</div>
                  <div className="col-2">{t("plan.custom_td_03")}</div>
                </div>
                <div className="column">
                  <div>
                    <ion-icon
                      name="checkmark-outline"
                      className="icon-check"
                    ></ion-icon>
                  </div>
                  <div>
                    <ion-icon
                      name="checkmark-outline"
                      className="icon-check"
                    ></ion-icon>
                  </div>
                  <div className="col-2">
                    {t("plan.custom_td_04")}
                    <br />
                    {t("plan.custom_td_05")}
                  </div>
                </div>
              </div>
            </div>
            <p className="notice">※ {t("plan.notice")}</p>
          </div>
        </section>
        <MailForm />
      </main>
    </>
  );
};

export default PricingPage;
